<section class="user-list__filters">
  <h1 class="user-list__title">Utilizadores</h1>
  <app-user-filters
    *ngIf="authService.isAuthenticated()"
    [formGroup]="viewModel.formGroup"
    (searchedValue)="onSearch($event)"
    [createPermissions]="userService.hasPermission('user_write')"
  ></app-user-filters>
</section>

<section class="user__content" *ngIf="authService.isAuthenticated()">
  <ng-template [ngIf]="authService.isAuthenticated()">
    <div class="user__container">
      <div class="user__section-table">
        <scc-dsm3-table
          [columns]="viewModel.columnsTable"
          [total]="totalItems"
          [rows]="tableData"
          labelCount="Utilizadores"
          [labelEmpty]="viewModel.emptyLabel"
          [hasExport]="true"
          labelExport="Exportar excel"
          (onExport)="onExport($event)"
          [checkLine]="false"
          [shadownLine]="false"
        >
          <scc-dsm3-tbody-column prop="userName">
            <ng-template let-column="column">
              <span class="user__tbody-span">{{ column.value }}</span>
            </ng-template>
          </scc-dsm3-tbody-column>

          <scc-dsm3-tbody-column prop="userAccount">
            <ng-template let-column="column">
              <span class="user__tbody-span">{{ column.value }}</span>
            </ng-template>
          </scc-dsm3-tbody-column>

          <scc-dsm3-tbody-column prop="retailerName">
            <ng-template let-column="column">
              <span class="user__tbody-span">{{ column.value }}</span>
            </ng-template>
          </scc-dsm3-tbody-column>

          <scc-dsm3-tbody-column prop="edit">
            <ng-template let-column="column" let-row="row">
              <span class="user-actions">
                <i class="icon icon--more-options icon--small" aria-hidden="true"></i>
                <ul class="user-actions__list">
                  <li class="user-actions__list-item">
                    <a
                      (click)="userService.editUser(column.row.userUniqueCode, route)"
                      [routerLink]="['/users/user-edit/']"
                      title="Editar utilizador"
                      >Editar utilizador</a
                    >
                  </li>
                  <li class="user-actions__list-item">
                    <a
                      href="#"
                      (click)="deleteUser(column.row); $event.preventDefault()"
                      (keydown.enter)="deleteUser(column.row); $event.preventDefault()"
                      (keydown.space)="deleteUser(column.row); $event.preventDefault()"
                      title="Eliminar utilizador"
                      >Eliminar utilizador</a
                    >
                  </li>
                </ul>
              </span>
            </ng-template>
          </scc-dsm3-tbody-column>
        </scc-dsm3-table>
      </div>
      <scc-dsm3-table-pagination-number
        #paginationControl
        [currentPage]="viewModel.currentUserRequestPage"
        [perPage]="viewModel.paginationPerPage"
        [total]="totalItems"
        [options]="viewModel.selectPaginationOption"
        [defaultOption]="20"
        (onChange)="paginationChanged($event)"
      >
      </scc-dsm3-table-pagination-number>
    </div>
  </ng-template>
</section>
